// @flow

import { type OutgoingPayment } from '@tectonics/prs/outgoing-payment/types';

export function sencillitoOutgoingPaymentMapper(): $Shape<OutgoingPayment> {

  return {
    payment_type: 'sencillito',
    payment_type_code: 'sencillito',
  };
}
